import React from 'react';
import map from 'lodash/map';
import find from 'lodash/find';
import { Button, Select, Tooltip } from 'antd';
import {
  DownOutlined,
  QuestionCircleOutlined,
  DesktopOutlined,
} from '@ant-design/icons';

import PageTitle from '@components/snippets/PageTitle';
import EditPlaylist from '@components/snippets/EditPlaylist';
import Badge from '@components/snippets/Badge';

const { Option } = Select;

function CalendarTitle({
  t,
  name,
  playlists,
  allPlaylists,
  devicesCount,
  onShowDevices,
  onRename,
  onCopy,
  onDelete,
  onAddPlaylist,
}) {
  const basePlaylist = find(playlists, ({ base }) => base) || {};

  const onSelectPlaylist = (id) => {
    onAddPlaylist(id)();
  };

  return (
    <PageTitle
      className="calendar-page__header cal-page-header"
      title={
        <>
          <div className="cal-page-header__title">{name}</div>
          <EditPlaylist
            name={name}
            onCopy={onCopy}
            onRename={onRename}
            onDelete={onDelete}
            withoutColor
            icon={<DownOutlined />}
          />
        </>
      }
      extra={
        <div className="calendar-page-header__extra">
          <div className="d-inline-block">
            <Tooltip
              overlayClassName="cal-page-header__help-tooltip"
              title={t('base-playlist-help')}
            >
              <QuestionCircleOutlined className="cal-page-header__help-icon" />
            </Tooltip>
            <span className="cal-page-header__help-text">
              {t('base-playlist')}
            </span>
          </div>
          <Select
            className="cal-page-header__select"
            value={basePlaylist.id}
            onChange={onSelectPlaylist}
            placeholder={t('select')}
          >
            {map(allPlaylists, ({ id, name, color }) => (
              <Option value={id}>
                <Badge color={color} />
                <div>{name}</div>
              </Option>
            ))}
          </Select>
          <Button
            onClick={onShowDevices}
            className="cal-page-header__devices-count"
            icon={<DesktopOutlined />}
            type="primary"
            ghost
          >
            {t('calendar-devices')} ({devicesCount})
          </Button>
        </div>
      }
    />
  );
}

export default CalendarTitle;
